import React from "react";

export default function DisAllowedAccess(reason) {
  const handleLogout = async () => {
    const dialogLogoutUrl =
      location.protocol +
      "//" +
      location.hostname +
      (location.port ? ":" + location.port : "") +
      "/logout.html";
    Office.context.ui.displayDialogAsync(
      dialogLogoutUrl,
      { height: 40, width: 30 },
      async (result) => {
        if (result.status === Office.AsyncResultStatus.Failed) {
          displayError(`${result.error.code} ${result.error.message}`);
        } else {
          Office.Dialog = result.value;
          Office.Dialog.addEventHandler(
            Office.EventType.DialogMessageReceived,
            processLogoutMessage
          );
        }
      }
    );
  };

  const processLogoutMessage = () => {
    setTimeout(() => {
      Office.Dialog.close();
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }, 3000);
  };

  if (reason.reason == "notKarnovUser") {
    return (
      <div className="notHaveAccessContainer">
        Denne appen er kun for karnov-brukere, og du er ikke en Karnov-bruker.
        <br />
        <br />
        Hvis du logget på med en annen konto enn Karnov-kontoen, først logge ut da logg på med en
        bruker med tilgang til Karnov, og last inn denne appen på nytt. Kontakt Karnov Support
        dersom du har behov for det. <br />
        <br />
        <button className="LogoutButton" onClick={() => handleLogout()}>
          Logg ut
        </button>
      </div>
    );
  } else if (reason.reason == "notKarnovDocument") {
    return (
      <div className="notHaveAccessContainer">
        Dette verktøyet fungerer bare for dokumenter laget for å skrive lovkommentarer hos Karnov
        Group Norway. Og dette dokumentet er ikke et karnov-dokument.
        <br /> <br />
        Vennligst sjekk filen eller url-en på nytt. Kontakt Karnov Support dersom du har behov for
        det.
      </div>
    );
  } else if (reason.reason == "authenticationFailed") {
    return (
      <div className="notHaveAccessContainer">
        Autentisering mislyktes. Vær så snill, prøv på nytt.
        <br /> <br />
        Kontakt Karnov Support dersom du har behov for det.
      </div>
    );
  } else {
    return (
      <div className="notHaveAccessContainer">
        Du har ikke tilgang til dette dokumentet. Kontakt Karnov Support dersom du har behov for
        det.
      </div>
    );
  }
}
